module.exports = __webpack_public_path__ + "media/images/favicon-05bdc1ff4fa5146f451c41505d471b7b.png";